export default "__VITE_ASSET__C15OJZnz__"